import React from 'react';
import Dropdown from 'components/dropdown';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { MenuItem } from 'react-bootstrap';
import EmailMetrics, { type MetricCardArgs } from './email_metrics';
import EmailIndex from './email_index';
import './styles.scss';

export default function PropertyEmailIndex() {
  const metrics: MetricCardArgs[] = [
    { label: 'Total Sent', value: '0', infoLabel: 'Total number of emails sent' },
    { label: 'Delivered', value: '0%', infoLabel: 'Successfully delivered emails' },
    { label: 'Opens', value: '0%', infoLabel: 'Number of opens recorded' },
    { label: 'Clicks', value: '0%', infoLabel: 'Unique link clicks' },
    { label: 'Bounced', value: '0%', infoLabel: 'Emails that bounced' },
    { label: 'Unsubscribes', value: '0%', infoLabel: 'Users who unsubscribed' },
  ];

  const renderHeader = () => {
    return (
      <div className="email-tab-title-header">
        <h1 className="email-tab-title">Email Performance</h1>
        <Dropdown className="ds-dropdown" id="email-actions-dropdown" pullRight>
          <UnstyledDropdownToggle bsRole="toggle" className="ds-button ds-button--accent ds-button--outlined gap-2">
            Actions
            <FontAwesomeIcon className="mb-1" icon={faCaretDown}/>
          </UnstyledDropdownToggle>
          <Dropdown.Menu>
            <MenuItem key="archive" name="archive" onClick={() => {}}>
              Archive
            </MenuItem>
            <MenuItem key="notifications" name="notifications" onClick={() => {}}>
              Notifications
            </MenuItem>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  return (
    <div className="email-tab">
      <div className="email-tab-header">
        {renderHeader()}
        <div className="metrics-container">
          {metrics.map(EmailMetrics)}
        </div>
      </div>
      <EmailIndex />
    </div>
  );
}
